import { render, staticRenderFns } from "./AreaMap.vue?vue&type=template&id=40a50171&scoped=true&"
import script from "./AreaMap.vue?vue&type=script&lang=js&"
export * from "./AreaMap.vue?vue&type=script&lang=js&"
import style0 from "./AreaMap.vue?vue&type=style&index=0&id=40a50171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a50171",
  null
  
)

export default component.exports